export default __webpack_public_path__ + "static/media/cadbury.f53c6fe2.jpg";